import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AppWebHeaderNarrow from '../AppWebHeaderNarrow';
import AppWebHeaderWide from '../AppWebHeaderWide';
var LayoutWebClassicHeader = React.forwardRef(function (_ref, ref) {
  var _ref$AppHeaderNarrowC = _ref.AppHeaderNarrowComponent,
      AppHeaderNarrowComponent = _ref$AppHeaderNarrowC === void 0 ? AppWebHeaderNarrow : _ref$AppHeaderNarrowC,
      _ref$AppHeaderWideCom = _ref.AppHeaderWideComponent,
      AppHeaderWideComponent = _ref$AppHeaderWideCom === void 0 ? AppWebHeaderWide : _ref$AppHeaderWideCom,
      rest = _objectWithoutProperties(_ref, ["AppHeaderNarrowComponent", "AppHeaderWideComponent"]);

  var theme = useTheme();
  var isWide = useMediaQuery(theme.breakpoints.up('md'));
  return isWide ? React.createElement(AppHeaderWideComponent, _extends({}, rest, {
    ref: ref
  })) : React.createElement(AppHeaderNarrowComponent, _extends({}, rest, {
    ref: ref
  }));
});
LayoutWebClassicHeader.propTypes = {
  appBarActions: PropTypes.elementType,
  AppHeaderNarrowComponent: PropTypes.elementType,
  AppHeaderWideComponent: PropTypes.elementType,
  appMenu: PropTypes.elementType,
  logo: PropTypes.elementType
};
LayoutWebClassicHeader.defaultProps = {
  appBarActions: undefined,
  AppHeaderNarrowComponent: undefined,
  AppHeaderWideComponent: undefined,
  appMenu: undefined,
  logo: undefined
};
export default LayoutWebClassicHeader;